import React from 'react';
import styles from './BrokerNumber.module.scss';

const BrokerNumber = ({ value, color = 'GREY' }) => {
  return (
    <span className={`${styles.BrokerNumber}  BrokerNumber`} data-color={color}>
      {value}
    </span>
  );
};

export default BrokerNumber;
